import React from "react";
import "./Navigationdowen.css";

import logo from "../img/logooo.png";
import insta from "../img2/instagram.png";
import phone from "../img/phone.png";
import whatsapp from "../img2/whatsapp.png";
import mail from "../img2/gmail.png";

const Navigationdowen = () => {
  return (
    <footer className="footer">

      {/* LOGO */}
      <div className="footer-logo">
        <img src={logo} alt="logo" />
        <p>בניית אתרים לעסקים</p>
      </div>

      {/* ICONS */}
      <div className="footer-icons">


        <a href="https://www.instagram.com/siteb2b/" className="icon" target="_blank" rel="noreferrer">
          <img src={insta} alt="instagram" />
          <span>אינסטגרם</span>
        </a>



      </div>

      <div className="footer-bottom">
        siteb2b© כל הזכויות שמורות | אתר נבנה על ידי siteb2b
      </div>

    </footer>
  );
};

export default Navigationdowen;